// Visit Verification — the whole pipeline between a clocked visit and the
// state: review and verify it, then watch it go to the aggregator and come
// back accepted or rejected.
//
// Two tabs over the pages that used to be two menu items. They were always
// sequential stages of one job, and a rejection had nowhere to go: the feed
// showed it, the desk did not. The visit_review view now raises EVV_REJECTED
// on the visit itself, so a rejected record lands back in the review queue
// with the aggregator's reason attached.
import { useSearchParams } from 'react-router-dom';
import VerificationDesk from './VerificationDesk';
import EvvFeed from './EvvFeed';

const TABS = [['review', 'Review & verify'], ['feed', 'EVV feed']];
const seg = (active) => ({ padding: '6px 14px', fontSize: 12, fontWeight: 500, cursor: 'pointer', fontFamily: 'inherit', border: 'none', background: active ? 'var(--accent)' : 'transparent', color: active ? 'var(--white)' : 'var(--text3)' });

export default function VisitVerification() {
  const [sp, setSp] = useSearchParams();
  const tab = TABS.some(([k]) => k === sp.get('tab')) ? sp.get('tab') : 'review';
  const setTab = (t) => setSp(prev => {
    const n = new URLSearchParams(prev);
    t === 'review' ? n.delete('tab') : n.set('tab', t);
    return n;
  }, { replace: true });

  return (
    <div>
      <div style={{ display: 'flex', border: '0.5px solid var(--border)', borderRadius: 8, overflow: 'hidden', width: 'fit-content', marginBottom: 14 }}>
        {TABS.map(([k, l]) => <button key={k} style={seg(tab === k)} onClick={() => setTab(k)}>{l}</button>)}
      </div>
      {tab === 'review' ? <VerificationDesk /> : <EvvFeed />}
    </div>
  );
}
